import { useContext } from 'react';
import { ThemeContext } from 'context/themeContext'
import { AppState } from 'App'

import { Sun, Moon } from 'components/misc/Icons'


const Toggle = () => {
    const [appState, setAppState] = useContext(AppState)
    const { theme, setTheme } = useContext(ThemeContext)
    return (
        <>
            <button
                onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark') | setAppState(prevState => ({...prevState,isMapDark:!appState.isMapDark}))}
                className="relative text-lighttext dark:text-darktext focus:outline-none">
                {theme === 'dark' ? <Sun width={6} height={6} stroke="1"/> : <Moon width={6} height={6} stroke="1"/>}
            </button>
        </>
    );
};

export default Toggle;
